export const Text = {
  variants: {
    adminFormLabel: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    info: {
      fontSize: 'sm',
      color: 'grey',
    },
    label: {
      color: 'grey',
      fontWeight: 'bold',
    },
    formSectionHeading: {
      fontSize: '18px',
      fontWeight: 600,
      color: 'baseBlack',
    },
    formlabel: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'baseBlack',
    },
    formErrorText: {
      fontSize: '12px',
      color: 'error',
      fontWeight: 400,
    },
    hyperlink: {
      color: 'grey',
      textDecoration: 'underline',
      _hover: {
        color: 'brand.primary',
      },
    },
    contentheader: {
      margin: 0,
      fontSize: '34px',
      fontWeight: '400',
    },
    heroheader: {
      as: 'h1',
      fontSize: '4xl',
      lineHeight: '1.2',
      fontWeight: '300',
    },
    pageheader: {
      as: 'h2',
      fontSize: '2xl',
      lineHeight: '1.2',
      fontWeight: '500',
    },
    createHeading: {
      fontSize: '16px',
      color: 'baseBlack',
      fontWeight: 600,
    },
    createLabel: {
      fontSize: '14px',
      color: 'baseBlack',
      fontWeight: 600,
    },
    createHelpText: {
      fontSize: 'sm',
      color: 'baseBlack',
      fontWeight: 400,
    },
    aiDescriptionHelpText: {
      fontSize: 'md',
      color: 'white',
      fontWeight: 600,
    },
    error: {
      fontSize: '16px',
      fontWeight: 400,
      color: 'error',
    },
    modalHeader: {
      fontSize: '20px',
      fontWeight: 600,
      color: 'baseBlack',
    },
  },
};
